<template>
  <v-row class="justify-center">
    <v-col cols="12" xl="5" class="not-found">
      <v-alert text flat color="grey darken-3">
        <h2 class="text-center">404: Page Not Found</h2>
        <div
          class="text-center"
        >Unfortunately the page you are looking for doesn't exists (anymore) or there was an error in the link you followed or typed.</div>

        <v-divider class="my-4 grey" style="opacity: 0.22"></v-divider>

        <v-row align="center" no-gutters>
          <v-col class="grow">
            <v-btn color="grey darken-3" text @click="stop; $router.go(-1);">
              <v-icon left>mdi-keyboard-backspace</v-icon>back to previous page
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="shrink">
            <v-btn color="grey darken-3" dark to="/">Take me to the Homepage</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style lang="scss" scoped>
.v-alert {
  background: #fff;
  box-shadow: none !important;

  &.v-alert--text::before {
    background: transparent;
  }

  h2 {
    font-size: 3rem;
    font-weight: bold;
    margin-bottom: 3rem;
  }
}
</style>